import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardMedia, CardContent, Typography, Button, Box } from '@mui/material';
import './CardItemVerbetes.css';

const CardItemVerbetes = ({ titulo, textoPortugues, autor, imgcard, linkid, showLink = true }) => {
  const createMarkup = (html) => ({ __html: html || '' });

  return (
    <Card
      sx={{
        width: '100%',
        maxWidth: 390,
        minHeight: 520,
        boxShadow: 4,
        borderRadius: 3,
        overflow: 'hidden',
        backgroundColor: '#FFF8E1',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardMedia
        component="img"
        image={imgcard}
        alt="Imagem do verbete"
        sx={{
          width: '100%',
          height: 220,
          objectFit: 'cover',
          backgroundColor: '#e7dcc7',
        }}
      />

      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 'bold',
            color: '#800020',
            textAlign: 'center',
            textTransform: 'uppercase',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            minHeight: '3.6em',
          }}
          dangerouslySetInnerHTML={createMarkup(titulo)}
        />

        <Typography
          variant="body2"
          sx={{
            color: '#5A3E36',
            textAlign: 'justify',
            display: '-webkit-box',
            WebkitLineClamp: 5,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            minHeight: '7em',
          }}
          dangerouslySetInnerHTML={createMarkup(textoPortugues)}
        />

        <Typography
          variant="body2"
          sx={{
            color: '#800020',
            fontStyle: 'italic',
            display: '-webkit-box',
            WebkitLineClamp: 1,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            minHeight: '1.5em',
          }}
          dangerouslySetInnerHTML={createMarkup(autor)}
        />
      </CardContent>

      {showLink && (
        <Box textAlign="center" mb={2} mt="auto">
          <Button
            variant="contained"
            component={Link}
            to={`/Verbetes/${linkid}`}
            sx={{
              fontWeight: 'bold',
              textTransform: 'uppercase',
              borderRadius: '25px',
              backgroundColor: '#800020',
              color: '#FFF8E1',
              padding: '12px 24px',
              fontSize: '16px',
              '&:hover': {
                backgroundColor: '#d4af37',
                color: '#800020',
                transform: 'scale(1.05)',
                transition: 'transform 0.3s ease, background-color 0.3s ease',
              },
            }}
          >
            Visualizar
          </Button>
        </Box>
      )}
    </Card>
  );
};


export default CardItemVerbetes;
